import { IconProps } from "./Icon.model";

export function MultiDotsIcon({ size = 15, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "var(--slate-11)" : `var(--${fill}-8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 1.25H1.25634M1.25 7.25H1.25634M1.25 13.25H1.25634M7.24683 1.25H7.25317M7.24683 7.25H7.25317M7.24683 13.25H7.25317M13.2437 1.25H13.25M13.2437 7.25H13.25M13.2437 13.25H13.25"
        stroke={fillColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

